import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../api/client";

/**
 * PageTracker — envoie un ping anonyme a /track a chaque changement de page.
 * A placer une seule fois, a l'interieur du Router (il utilise useLocation).
 *
 * Aucune donnee personnelle : le backend ne conserve que des compteurs agreges
 * (voir app/analytics). Ne rend rien.
 */
export default function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    // On ne suit pas l'espace d'administration (trafic interne).
    if (location.pathname.startsWith("/admin")) return;
    api.post("/track", { chemin: location.pathname }).catch(() => { /* silencieux */ });
  }, [location.pathname]);
  return null;
}
